import React, { Component } from 'react';

import {connect} from "react-redux";
import Header from "./components/header";
import Footer from "./components/footer";
import { withRouter } from "react-router-dom";
import { BrowserRouter, Route, Switch, StaticRouter } from "react-router-dom";
import Sitemenu from "./components/sitemenu";
import SideBanners from "./components/sidebanners";

import PageListen from "./components/pagelisten";
import * as wActs from "./actions/website-actions";
import {Helmet} from "react-helmet";
import { IntlProvider } from 'react-intl';
import AgeVerify from './components/ageverify';
import SendMessage from './components/sendmessage';
import Warning from './components/warning';
import BreadCrumbs from "./components/breadcrumbs";
import HtmlSection from "./components/htmlsection";
import {isMobile} from "react-device-detect";
import SeoHeaders from "./components/SeoHeaders";
import BuyAdsBanner from "./components/buyadsbanner";
import SwBanner from "./components/swbanner";
import SsrBanner from "./components/ssrbanner";
import * as sActs from "./actions/server-actions";

//import ChatWrapper from './chat/components/chatwrapper';

class App extends Component {

  constructor(props) {
    super(props);
    this.state = {
      pageType: props.pageType
    };
     //this.setPage = this.setPage.bind(this);
  }


  componentDidMount() {
    if (typeof window !== "undefined") {
      if (sActs.getServerCookie(this.props.Website.ServerParams.Cookies, "anon") === null) {
        wActs.setCookie("anon", this.props.Website.Request.AnonymousId, { path: "/", maxAge: 31557600, domain: "." + wActs.getSubdomain(window.location.hostname) });
      }
    }
  }

  handleScroll(e) {
    //console.log(window.scrollY);

  }

  smallWidth() {
    if(typeof window !== "undefined") {
      if(window.innerWidth < 767) {
        //console.log("here");
        return true
      }
    } else {
      return false;
    }
    return false;
  }

  getTranslation(key,def) {
    let t = this.props.Website.Translations[key];
    if(!wActs.isNullOrUndefined(t)) return t;
    return def;
  }

  getFilterTitle(nme) {
    if(nme=="ournetwork") return this.getTranslation("page.advertise.ournetwork");
    if(nme=="other") return this.getTranslation("menu.other");
    return nme;
  }

  getTitle(title) {
    let page = title;
    let furl = "https://www.fake.com/"
    if(typeof window === "undefined") {
      furl = furl + this.props.Website.ServerParams.Query;
    } else {
      furl = window.location.href;
    }
    if(wActs.getParameterByName("page",furl,"") !== "") {
      page = this.getTranslation("page.pagex").replace("{{pagenumber}}", wActs.getParameterByName("page", furl, "")) + " - " + page;
    }

    let filter = "";
    let filters = wActs.getParameterByName("filter",furl,"");
    if(!wActs.isNullOrEmpty(filters)) {
      filters = filters.split(",");
      if(filters.length>0) {
        filter = this.getFilterTitle(filters[0]);
      }
    }

    if(!wActs.isNullOrEmpty(filter)) {
      page = filter + " - " + page;
    }

    return page;
  }




  render() {
    //throw new Error("Error Dude");
    if(!this.props.SiteLoaded) {
      return (
      <div id={"loadingDiv"}>
      </div>
      );
    }


    return (
      <div className="App" id={"mainApp"}>
        {this.props.Website.PageLoaded &&
          <Helmet>
            <title>{this.getTitle(this.props.Website.Page.Title)}</title>
            {!this.props.Website.Page.HideKeywords &&
            <meta name="keywords" content={this.props.Website.Page.Keywords} />
            }
            <meta name="description" content={this.props.Website.Page.Description} />
            {
              this.props.Website.Page.Properties.map((v,i) => {
                if(v.Name.startsWith("twitter:")) {
                  return <meta key={"set-" + i} name={v.Name} content={v.Content}/>;
                } else {
                  return <meta key={"set-" + i} property={v.Name} content={v.Content}/>;
                }
              })
            }
            {
              this.props.Website.Page.Icons.map((v,i) => {
                return <link key={"ico-" + i} rel={v.Rel} sizes={v.Sizes} type={v.Type} href={v.Href} />;
              })
            }
            {!wActs.isNullOrUndefined(this.props.Website.Page.References) &&
              this.props.Website.Page.References.filter((t) => { return t.Rel.toLowerCase() === "alternate" }).map((v, i) => {
                return <link key={"alt-" + i} rel={v.Rel} href={v.Href === "" ? "/" : v.Href} hrefLang={v.HrefLang} />;
              })
            }
            {!wActs.isNullOrUndefined(this.props.Website.Page.References) &&
              this.props.Website.Page.References.filter((t)=>{return t.Rel.toLowerCase() === "canonical"}).map((v,i) => {
                return <link key={"can-" + i} rel={v.Rel} href={v.Href} />;
              })
            }
            {this.props.Website.Page.NoIndex &&
            <meta name="robots" content="noindex"/>
            }
          </Helmet>
        }
        <IntlProvider locale={this.props.Website.TranslationsLocal} defaultlocale={'en'} messages={this.props.Website.Translations} >

            <div>
              {typeof window !== "undefined" && <PageListen/>}
              <Header pageType={this.props.Website.PageType} />
              <BreadCrumbs type={"home"}/>
              {this.props.children}
              <Footer/>
              <Warning/>
              <HtmlSection Id={"Pingdom"}/>

              {this.props.Website.Page.Name === "Home" &&
              <div style={{display: "flex", justifyContent: "center", paddingBottom: "15px"}}><HtmlSection Id={"HomePageBottom"}/></div>
              }

              <div style={{display: "flex", justifyContent: "center", paddingBottom: "15px"}}><HtmlSection Id={"RedlightDistrictLink"}/></div>
              <div style={{display: "flex", justifyContent: "center", paddingBottom: "15px"}}><HtmlSection Id={"DMCA"}/></div>
              <HtmlSection Id={"Onesignal"}/>
              {!this.props.Website.ServerParams.IsMobile &&
                <HtmlSection Id={"LivejasminChatHead"}/>
              }
              {!wActs.isNullOrUndefined(this.props.Website.Settings) && this.props.Website.Settings.ShowAdultWarning &&
                <AgeVerify/>
              }
            </div>
        </IntlProvider>
      </div>
    );
  }

}

function exportWithRouter() {
  if (typeof window !== "undefined") {
    return withRouter(connect(mapStateToProps)(App));
  } else {
    return connect(mapStateToProps)(App);
  }
}



const mapStateToProps = (state) => {
  return {
    HasMore: state.ProfilesList.HasMore,
    LastPull: state.ProfilesList.LastPull,
    ProfilesData: state.ProfilesList.ProfilesData,
    State: state.ProfilesList.State,
    SiteLoaded: state.Website.Loaded,
    Website: state.Website

  };
};



export default exportWithRouter(); //Added This To Support Pageless Once SSR Is Done.. Only Works Client Withrouter, And Without SSR
